import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=4c0619a4&scoped=true&"
import script from "./HomeIndex.vue?vue&type=script&lang=js&"
export * from "./HomeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0619a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0619a4')) {
      api.createRecord('4c0619a4', component.options)
    } else {
      api.reload('4c0619a4', component.options)
    }
    module.hot.accept("./HomeIndex.vue?vue&type=template&id=4c0619a4&scoped=true&", function () {
      api.rerender('4c0619a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/HomeIndex.vue"
export default component.exports